/**
 * Created by pony.ma@nirvana-info on .
 */
let config = {
  isAuth: false,
  // apiName: 'local',
  apiName: 'unLogin',
  dev: true
}

if (process.env.NODE_ENV === 'production') {
  config.isAuth = true
  config.apiName = 'login'
}

export default config



// WEBPACK FOOTER //
// ./src/config/dev.js